export enum SolutionPickerEntryId {
  EMPTY_CART_PAGE = 'VY7kLQSq4eZupGpRYUKmS',
  NOT_FOUND_PAGE = '58j3okL7GA4VFajvr7IeiX',
}
